const defaultState = {
    productionCenters: [],
    selectedProductionCenters: [],
    loading: false,
    errors:{}
  }
  
export default (state=defaultState, action={}) => {
    switch (action.type) {

      case 'FETCH_PRODUCTION_CENTERS_FULFILLED': {
        return {
          ...state,
          productionCenters: action.payload.data,
          loading: false,
          errors: {}
        }
      }
  
      case 'FETCH_PRODUCTION_CENTERS_PENDING': {
        return {
          ...state,
          loading: true,
          errors: {}
        }
      }
  
      case 'FETCH_PRODUCTION_CENTERS_REJECTED': {
        return {
          ...state,
          loading: false,
          errors: { global: action.payload.message }
        }
      }

      case 'SELECT_PRODUCTION_CENTERS': {
        return {
          ...state,
          selectedProductionCenters: action.payload.selectedProductionCenters,
          loading: false,
          errors: {}
        }
      }      
      
      default:
        return state;
    }
  }



// WEBPACK FOOTER //
// ./src/reducers/center-reducer.js